import jquery from 'jquery';
import 'jquery-migrate';

// Expose jQuery
window.jQuery = jquery;
window.$ = jquery;

// Disable migrate traces.
jQuery.migrateTrace = false;